<style global>
    @tailwind base;
    @tailwind components;
    @tailwind utilities;

    .font-pacifico {
        font-family: Pacifico;
    }
    .font-italianno {
        font-family: Italianno;
    }
    button {
        @apply font-semibold py-2 px-3 rounded;
    }
    button:not([variant]) {
        @apply bg-blue-600 text-white;
    }
    button:not([variant]):hover {
        @apply bg-blue-500;
    }
    [variant='error'] {
        @apply bg-red-500 text-white;
    }
    [variant='error']:hover {
        @apply bg-red-600;
    }
    button:disabled {
        @apply opacity-50 cursor-not-allowed;
    }
    div.group {
        @apply inline-flex;
    }
    .group button.active {
        @apply bg-blue-500;
    }
    .group button:last-of-type {
        @apply rounded-r;
    }
    .group button:first-of-type {
        @apply rounded-l;
    }
    .group button {
        @apply rounded-none bg-blue-300 py-1;
    }
    table.border td,
    th {
        @apply border;
    }
    table.sticky th {
        @apply align-top;
    }
    table.sticky thead {
        @apply sticky top-0 bg-white;
    }
    table td,
    th {
        @apply px-4 py-2;
    }
    table.sm td,
    th {
        @apply px-2 py-1;
    }
    thead,
    tfoot {
        @apply font-bold;
    }
    input {
        @apply px-2 py-1 border rounded;
    }
    h5 {
        @apply text-xl my-3;
    }
</style>

<script>
    import { Router } from '@sveltech/routify';
    import { routes } from '@sveltech/routify/tmp/routes';
    import { traerProductos } from './pages/productos/_productos.svelte';

    traerProductos();
</script>

<Router {routes} />
